import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE });

export const api = {
  // employees
  listEmployees: (includeInactive = true) =>
    client.get(`/employees`, { params: { include_inactive: includeInactive } }).then((r) => r.data),
  createEmployee: (data) => client.post(`/employees`, data).then((r) => r.data),
  updateEmployee: (id, data) => client.put(`/employees/${id}`, data).then((r) => r.data),
  deleteEmployee: (id) => client.delete(`/employees/${id}`).then((r) => r.data),

  // settings
  getSettings: () => client.get(`/settings`).then((r) => r.data),
  updateSettings: (data) => client.put(`/settings`, data).then((r) => r.data),

  // custom kpis
  listKpis: () => client.get(`/custom-kpis`).then((r) => r.data),
  createKpi: (data) => client.post(`/custom-kpis`, data).then((r) => r.data),
  updateKpi: (id, data) => client.put(`/custom-kpis/${id}`, data).then((r) => r.data),
  deleteKpi: (id) => client.delete(`/custom-kpis/${id}`).then((r) => r.data),

  // targets
  getTargets: (month) => client.get(`/targets`, { params: { month } }).then((r) => r.data),
  upsertTarget: (data) => client.post(`/targets`, data).then((r) => r.data),
  copyTargets: (from_month, to_month) =>
    client.post(`/targets/copy`, null, { params: { from_month, to_month } }).then((r) => r.data),

  // entries
  listEntries: (params) => client.get(`/entries`, { params }).then((r) => r.data),
  getEntry: (employee_id, date) => client.get(`/entry`, { params: { employee_id, date } }).then((r) => r.data),
  saveEntry: (data) => client.post(`/entries`, data).then((r) => r.data),
  deleteEntry: (id, changed_by) => client.delete(`/entries/${id}`, { params: { changed_by } }).then((r) => r.data),
  auditLog: (entry_id) => client.get(`/audit-log`, { params: { entry_id } }).then((r) => r.data),

  // analytics
  overview: (period, date) => client.get(`/overview`, { params: { period, date } }).then((r) => r.data),
  analytics: (params) => client.get(`/analytics`, { params }).then((r) => r.data),
  monthlyComparison: (month, employee_id) =>
    client.get(`/analytics/monthly-comparison`, { params: { month, employee_id } }).then((r) => r.data),
  scoring: (params) => client.get(`/scoring`, { params }).then((r) => r.data),

  // goals
  getGoals: (month) => client.get(`/goals`, { params: { month } }).then((r) => r.data),
  saveGoals: (data) => client.post(`/goals`, data).then((r) => r.data),
  goalsActuals: (month) => client.get(`/goals/actuals`, { params: { month } }).then((r) => r.data),

  // manager
  managerList: (kind) => client.get(`/manager/${kind}`).then((r) => r.data),
  managerCreate: (kind, data) => client.post(`/manager/${kind}`, data).then((r) => r.data),
  managerUpdate: (kind, id, data) => client.put(`/manager/${kind}/${id}`, data).then((r) => r.data),
  managerDelete: (kind, id) => client.delete(`/manager/${kind}/${id}`).then((r) => r.data),
  managerScorecard: (start, end) =>
    client.get(`/manager/scorecard`, { params: { start, end } }).then((r) => r.data),
  kpiEvidence: (employee_id, start, end) =>
    client.get(`/manager/kpi-evidence`, { params: { employee_id, start, end } }).then((r) => r.data),
};

export function apiErrors(err) {
  const d = err?.response?.data?.detail;
  if (d && d.errors) return d.errors;
  if (typeof d === "string") return [d];
  return ["Something went wrong. Please try again."];
}
